import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressBar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_575_3969)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_575_3969)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_575_3969",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 32,
				height: 32,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M31.7814 0.25H0.219727V31.8116H31.7814V0.25Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_575_3969)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "mask1_575_3969",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 1,
					y: 6,
					width: 30,
					height: 20,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M30.4657 6.8252H1.53418V25.2362H30.4657V6.8252Z",
						fill: "white"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask1_575_3969)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M26.8492 25.2361H5.15062C3.16158 25.2361 1.53418 23.4684 1.53418 21.3078C1.53418 19.1472 3.16158 17.3794 5.15062 17.3794H26.8492C28.8383 17.3794 30.4657 19.1472 30.4657 21.3078C30.4657 23.4684 28.8383 25.2361 26.8492 25.2361ZM5.15062 18.6889C3.82459 18.6889 2.73966 19.8674 2.73966 21.3078C2.73966 22.7482 3.82459 23.9267 5.15062 23.9267H26.8492C28.1753 23.9267 29.2602 22.7482 29.2602 21.3078C29.2602 19.8674 28.1753 18.6889 26.8492 18.6889H5.15062Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.6164 22.4213H5.15065C4.58406 22.4213 4.12598 21.9237 4.12598 21.3082C4.12598 20.6928 4.58406 20.1952 5.15065 20.1952H19.6164C20.183 20.1952 20.6411 20.6928 20.6411 21.3082C20.6411 21.9237 20.183 22.4213 19.6164 22.4213Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M13.1784 10.0859C12.8771 9.73227 12.7324 9.27397 12.7324 8.72401C12.7324 8.17405 12.8771 7.70264 13.1784 7.36217C13.4798 7.00864 13.8535 6.83838 14.3237 6.83838C14.7938 6.83838 15.1795 7.00864 15.4689 7.36217C15.7582 7.7157 15.9028 8.17405 15.9028 8.73712C15.9028 9.30019 15.7582 9.75849 15.4689 10.0989C15.1795 10.4525 14.7938 10.6227 14.3237 10.6227C13.8535 10.6227 13.4798 10.4525 13.1784 10.0989V10.0859ZM13.4919 14.6558L16.0716 10.662L18.2897 6.96932H19.4349L16.7949 11.0417L14.6371 14.669H13.4798L13.4919 14.6558ZM14.7938 9.48351C14.9143 9.28708 14.9626 9.03827 14.9626 8.72401C14.9626 8.40975 14.9023 8.13473 14.7938 7.95141C14.6853 7.76809 14.5286 7.66337 14.3237 7.66337C14.1187 7.66337 13.9741 7.75503 13.8535 7.95141C13.733 8.13473 13.6848 8.39665 13.6848 8.72401C13.6848 9.05138 13.745 9.30019 13.8656 9.48351C13.9861 9.67989 14.1428 9.77155 14.3357 9.77155C14.5286 9.77155 14.6853 9.67989 14.8058 9.48351H14.7938ZM17.4338 14.263C17.1445 13.9095 16.9998 13.4512 16.9998 12.8881C16.9998 12.325 17.1445 11.8798 17.4338 11.5262C17.7231 11.1727 18.1089 11.0025 18.5669 11.0025C19.025 11.0025 19.4228 11.1727 19.7121 11.5262C20.0015 11.8798 20.1461 12.325 20.1461 12.8881C20.1461 13.4512 20.0015 13.9095 19.7121 14.263C19.4228 14.6166 19.0371 14.7868 18.5669 14.7868C18.0968 14.7868 17.7231 14.6166 17.4338 14.263ZM19.0371 13.6606C19.1576 13.4642 19.2058 13.2155 19.2058 12.8881C19.2058 12.5607 19.1456 12.2988 19.0371 12.1155C18.9286 11.9322 18.7719 11.8405 18.5669 11.8405C18.362 11.8405 18.2174 11.9322 18.0968 12.1286C17.9883 12.3119 17.928 12.5738 17.928 12.8881C17.928 13.2023 17.9883 13.4642 18.0968 13.6606C18.2174 13.8571 18.362 13.9487 18.5669 13.9487C18.7719 13.9487 18.9165 13.8571 19.025 13.6606H19.0371Z",
							fill: "currentColor"
						})
					]
				})]
			})]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_575_3969",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_575_3969",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 31.5616,
			height: 32,
			fill: "white",
			transform: "translate(0.219727)"
		})
	})] })]
});
export default SvgProgressBar;
